import { useContext, useEffect, useState } from 'react'
import Button from 'ui/src/components/controls/button'
import { EditPanelFieldComponentProps } from '..'
import UrlInput from '../../../controls/url'
import { CONTROL_SIZE, CONTROL_SIZE_SLIM, SAVE_BUTTON_LABEL, SAVE_BUTTON_WIDTH } from '../../constants'
import { EditPanelFieldContext } from '../../contexts/field'
import { EditPanelContext } from '../../contexts/panel'
import { titleFromField, valueKeyFromField } from '../../utilities/field'
import { sharedValueFromGifs } from '../../utilities/gifs'

export default ({ className, field, gifId, size: sizeProp }: EditPanelFieldComponentProps) => {
    const { colors, gifs, isCompact } = useContext(EditPanelContext)
    const { changeField } = useContext(EditPanelFieldContext)
    const size = sizeProp || (isCompact ? CONTROL_SIZE_SLIM : CONTROL_SIZE)
    const key = valueKeyFromField(field)
    const defaultValue = sharedValueFromGifs<string>(gifs, key, gifId) || ''
    const title = titleFromField(field)
    const placeholder = `Add ${title.toLowerCase()}`
    const [value, setValue] = useState<string>(defaultValue)

    function onSave() {
        if (value !== defaultValue) {
            changeField(field, value)
        }
    }

    useEffect(() => {
        setValue(defaultValue)
    }, [gifId])

    return (
        <UrlInput
            className={className}
            color={colors.input}
            defaultValue={value}
            placeholder={placeholder}
            selectOnFocus
            size={size}
            onChange={setValue}
            onEnterKeyPress={() => onSave()}
        >
            <Button
                color={colors.saveButton || colors.button}
                size={size}
                style={{ width: SAVE_BUTTON_WIDTH }}
                textColor={colors.saveButtonText || colors.buttonText}
                onClick={() => onSave()}
            >
                {SAVE_BUTTON_LABEL}
            </Button>
        </UrlInput>
    )
}
